(function() {
  'use strict';

  var buttonTexts = {
    accept: ['accept', 'allow', 'accepter', 'tillad'],
    decline: ['decline', 'reject', 'afvis', 'afslå'],
    manage: ['manage', 'preferences', 'settings', 'customize', 'administrer', 'indstillinger', 'tilpas', 'gem']
  };

  function includesButtonText(text, values) {
    return values.some(function(value) { return text.includes(value); });
  }

  function getCopy() {
    var isDanish = (document.documentElement.lang || '').toLowerCase().indexOf('da') === 0;

    if (isDanish) {
      return {
        title: 'Cookieindstillinger',
        intro: 'Vælg hvilke cookies du tillader. Du kan ændre disse indstillinger når som helst.',
        requiredName: 'Nødvendige',
        requiredDescription: 'Nødvendige for at sitet fungerer — login, kurv og checkout.',
        preferencesName: 'Præferencer',
        preferencesDescription: 'Husker dine valg for en bedre oplevelse.',
        marketingName: 'Markedsføring',
        marketingDescription: 'Bruges af os og vores partnere til at vise relevante annoncer.',
        analyticsName: 'Statistik',
        analyticsDescription: 'Hjælper os med at forstå, hvordan du bruger sitet.',
        close: 'Luk',
        accept: 'Acceptér alle',
        save: 'Gem mine valg',
        decline: 'Afvis alle'
      };
    }

    return {
      title: 'Cookie preferences',
      intro: 'Choose which cookies you allow. You can change these settings at any time.',
      requiredName: 'Required',
      requiredDescription: 'Necessary for the site to function — login, cart, checkout.',
      preferencesName: 'Preferences',
      preferencesDescription: 'Remember your choices for a better experience.',
      marketingName: 'Marketing',
      marketingDescription: 'Used by us and our partners to show relevant ads.',
      analyticsName: 'Analytics',
      analyticsDescription: 'Help us understand how you use the site.',
      close: 'Close',
      accept: 'Accept all',
      save: 'Save my choices',
      decline: 'Decline all'
    };
  }

  function el(tag, attrs, children) {
    var node = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function(k) {
      if (k === 'text') { node.textContent = attrs[k]; return; }
      if (k === 'className') { node.className = attrs[k]; return; }
      node.setAttribute(k, attrs[k]);
    });
    if (children) children.forEach(function(c) { if (c) node.appendChild(c); });
    return node;
  }

  function createCat(name, desc, key, locked) {
    var cb = el('input', { type: 'checkbox', 'data-cat': key });
    cb.checked = false;
    if (locked) {
      cb.checked = true;
      cb.disabled = true;
    }
    var strong = el('strong', { text: name });
    var lbl = el('label', {}, [cb, document.createTextNode(' '), strong]);
    var p = el('p', { text: desc });
    return el('div', { className: 'so-cp-cat' }, [lbl, p]);
  }

  var BACKDROP_CLASS = 'so-cc-backdrop';

  function bannerIsVisible() {
    var banner = document.getElementById('shopify-pc__banner');
    if (!banner || !banner.isConnected) return false;
    /* offsetParent is always null for position: fixed, so read computed display. */
    return window.getComputedStyle(banner).display !== 'none';
  }

  function showBackdrop() {
    if (document.querySelector('.' + BACKDROP_CLASS)) return;
    document.body.appendChild(el('div', { className: BACKDROP_CLASS }));
    document.documentElement.style.overflow = 'hidden';
  }

  function hideBackdrop() {
    var backdrop = document.querySelector('.' + BACKDROP_CLASS);
    if (backdrop) backdrop.remove();
    document.documentElement.style.overflow = '';
  }

  function syncBackdrop() {
    if (bannerIsVisible()) showBackdrop();
    else hideBackdrop();
  }

  function createPrefsModal() {
    if (document.getElementById('so-cookie-prefs')) return;

    var copy = getCopy();
    var overlay = el('div', { id: 'so-cookie-prefs' });
    var backdrop = el('div', { className: 'so-cp-backdrop' });

    var closeBtn = el('button', { className: 'so-cp-close', 'aria-label': copy.close, text: '\u00D7' });
    var title = el('h2', { text: copy.title });
    var header = el('div', { className: 'so-cp-header' }, [title, closeBtn]);

    var intro = el('p', { className: 'so-cp-intro', text: copy.intro });
    var body = el('div', { className: 'so-cp-body' }, [
      intro,
      createCat(copy.requiredName, copy.requiredDescription, 'necessary', true),
      createCat(copy.preferencesName, copy.preferencesDescription, 'preferences', false),
      createCat(copy.marketingName, copy.marketingDescription, 'marketing', false),
      createCat(copy.analyticsName, copy.analyticsDescription, 'analytics', false)
    ]);

    var acceptBtn = el('button', { className: 'so-cp-btn so-cp-accept', text: copy.accept });
    var saveBtn = el('button', { className: 'so-cp-btn so-cp-save', text: copy.save });
    var declineBtn = el('button', { className: 'so-cp-btn so-cp-decline', text: copy.decline });
    var footer = el('div', { className: 'so-cp-footer' }, [acceptBtn, saveBtn, declineBtn]);

    var dialog = el('div', { className: 'so-cp-dialog', role: 'dialog', 'aria-label': copy.title }, [header, body, footer]);

    overlay.appendChild(backdrop);
    overlay.appendChild(dialog);
    document.body.appendChild(overlay);

    var didSetConsent = false;

    function close() {
      var banner = document.getElementById('shopify-pc__banner');
      if (!didSetConsent && banner) banner.style.display = '';
      overlay.style.display = 'none';
      document.body.style.overflow = '';
    }

    function setConsent(prefs, marketing, analytics) {
      try {
        if (window.Shopify && window.Shopify.customerPrivacy) {
          window.Shopify.customerPrivacy.setTrackingConsent({
            marketing: marketing,
            analytics: analytics,
            preferences: prefs,
            sale_of_data: marketing
          }, function() {});
          didSetConsent = true;
        }
      } catch(e) {}

      var banner = document.getElementById('shopify-pc__banner');
      if (banner) banner.style.display = 'none';
      var nativePrefs = document.getElementById('shopify-pc__prefs');
      if (nativePrefs) nativePrefs.style.display = 'none';
      hideBackdrop();
      close();
    }

    closeBtn.addEventListener('click', close);
    backdrop.addEventListener('click', close);
    dialog.addEventListener('click', function(e) { e.stopPropagation(); });

    acceptBtn.addEventListener('click', function() { setConsent(true, true, true); });
    declineBtn.addEventListener('click', function() { setConsent(false, false, false); });
    saveBtn.addEventListener('click', function() {
      var p = overlay.querySelector('[data-cat="preferences"]').checked;
      var m = overlay.querySelector('[data-cat="marketing"]').checked;
      var a = overlay.querySelector('[data-cat="analytics"]').checked;
      setConsent(p, m, a);
    });
  }

  function showPrefsModal() {
    createPrefsModal();
    var overlay = document.getElementById('so-cookie-prefs');
    overlay.style.display = 'block';
    document.body.style.overflow = 'hidden';
  }

  function interceptManagePrefs() {
    document.addEventListener('click', function(e) {
      var btn = e.target.closest ? e.target.closest('button') : null;
      if (!btn) return;
      var banner = document.getElementById('shopify-pc__banner');
      if (!banner || !banner.contains(btn)) return;
      var t = (btn.textContent || '').trim().toLowerCase();
      if (includesButtonText(t, buttonTexts.manage)) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        showPrefsModal();
      }
    }, true);
  }

  function enhance() {
    var banner = document.getElementById('shopify-pc__banner');
    if (!banner) return;
    var buttons = banner.querySelectorAll('button');
    var accept = null, decline = null;
    buttons.forEach(function(btn) {
      var t = (btn.textContent || '').trim().toLowerCase();
      if (includesButtonText(t, buttonTexts.accept)) {
        accept = btn;
        btn.classList.add('so-cookie-action--accept');
      } else if (includesButtonText(t, buttonTexts.decline)) {
        decline = btn;
        btn.classList.add('so-cookie-action--decline');
      } else if (includesButtonText(t, buttonTexts.manage)) {
        btn.classList.add('so-cookie-action--manage');
      }
    });
    if (accept && decline && accept.parentNode === decline.parentNode) {
      accept.parentNode.insertBefore(accept, decline);
    }
  }

  /* Shopify injects the banner asynchronously and dismisses it by either removing
     the node or hiding it, so watch both its parent and its own attributes. */
  function watchBanner(banner) {
    new MutationObserver(syncBackdrop).observe(banner, {
      attributes: true,
      attributeFilter: ['style', 'class', 'hidden']
    });
    if (banner.parentNode) {
      new MutationObserver(syncBackdrop).observe(banner.parentNode, { childList: true });
    }
  }

  function onBannerReady() {
    var banner = document.getElementById('shopify-pc__banner');
    if (!banner) return false;
    enhance();
    watchBanner(banner);
    syncBackdrop();
    return true;
  }

  function init() {
    interceptManagePrefs();
    document.addEventListener('visitorConsentCollected', hideBackdrop);
    onBannerReady();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.SOCookiePrefs = { open: showPrefsModal };

  var obs = new MutationObserver(function() {
    if (onBannerReady()) obs.disconnect();
  });
  if (document.body) obs.observe(document.body, { childList: true, subtree: true });
})();
